import { useConnectionStore } from '../../stores/connectionStore';
import { WifiOff, Loader2 } from 'lucide-react';

const ConnectionStatus = () => {
  const { status, reconnectAttempt, maxReconnectAttempts } = useConnectionStore();

  // Не показываем индикатор при стабильном соединении
  if (status === 'connected' || status === 'disconnected') {
    return null;
  }

  const getStatusConfig = () => {
    switch (status) {
      case 'connecting':
        return {
          icon: <Loader2 className="w-4 h-4 animate-spin" />,
          text: 'Подключение...',
          bgColor: 'bg-blue-500/90',
        };
      case 'reconnecting':
        return {
          icon: <Loader2 className="w-4 h-4 animate-spin" />,
          text: `Переподключение (${reconnectAttempt}/${maxReconnectAttempts})...`,
          bgColor: 'bg-yellow-500/90',
        };
      case 'failed':
        return {
          icon: <WifiOff className="w-4 h-4" />,
          text: 'Соединение потеряно',
          bgColor: 'bg-red-500/90',
        };
      default:
        return null;
    }
  };

  const config = getStatusConfig();
  if (!config) return null;

  return (
    <div className={`fixed top-4 left-1/2 transform -translate-x-1/2 z-50 ${config.bgColor} text-white px-4 py-2 rounded-full shadow-lg flex items-center gap-2`}>
      {config.icon}
      <span className="text-sm font-medium">{config.text}</span>
    </div>
  );
};

export default ConnectionStatus;
